import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TablePagination,
  TableFooter,
  Typography,
  Button
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  image: {
    height: '50px',
    width: 'auto'
  },
  container: {
    padding: theme.spacing(3)
  },
  head: {
    '& .MuiTableCell-head': {
      borderBottomColor: 'rgba(0,0,0,0.6)'
    }
  },
  noResults: {

  },
  selectBtn: {
    marginRight: theme.spacing(2)
  }
}));

const ItemSearcesList = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  if(!props.items || !props.items.length) {
    if(props.showNoResultsMessage) {
      return (
        <Typography variant="subtitle1" component="p" align="center">{t('itemSearch:noSavedSearches')}</Typography>
      );
    } else {
      return null;
    }
  }

  const visibleRows = props.items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer>
      <Table>
        <TableHead className={classes.head}>
          <TableRow>
            <TableCell><Typography variant="overline">{t('itemSearch:operator')}</Typography></TableCell>
            <TableCell><Typography variant="overline">{t('itemSearch:parameters')}</Typography></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {visibleRows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{t(`itemSearch:${row.data.activeOperator === 'AND' ? 'all' : 'any'}`)}</TableCell>
              <TableCell>
                {row.data.activeFilters.map(filter =>
                  <p key={`${row.id}-${filter.id}`}>{filter.field} {t(`itemSearch:${filter.operation}`)} {Array.isArray(filter.value) ? filter.value.join(` ${t('common:or')} `) : filter.value}</p>
                )}
              </TableCell>
              <TableCell align="right">
                <Button color="primary" variant="contained" disableElevation onClick={() => props.handleSelect(row)} className={classes.selectBtn}>{t('itemSearch:searchItems')}</Button>
                <Button variant="contained" disableElevation onClick={() => props.handleDelete(row.id)}>{t('itemSearch:deleteSavedSearch')}</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[25, 50, 75, 100]}
              colSpan={6}
              count={props.items.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

ItemSearcesList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  handleDelete: PropTypes.func,
  handleSelect: PropTypes.func,
  showNoResultsMessage: PropTypes.bool
}

export default ItemSearcesList;
